// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"e58a2140","774":"2342bf34","981":"b0f90951"}[chunkId] + ".chunk.js";
};